import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { StorageLCPImage } from '@/components/atoms/StorageImage';
import { BaseExperienceCard } from './BaseExperienceCard';
import type { ExperienceCardLCPProps } from './types';
export const ExperienceCardLCP: FC<ExperienceCardLCPProps> = t0 => {
  const $ = _c(10);
  const {
    ee_name,
    ee_img,
    id,
    auction,
    celebrity
  } = t0;
  let t1;
  if ($[0] !== ee_img || $[1] !== ee_name) {
    t1 = <StorageLCPImage src={ee_img} alt={ee_name} width={327} height={327} className="h-full w-full object-cover" sizes="(min-width: 1280px) 384px, (min-width: 768px) 343px, 343px" />;
    $[0] = ee_img;
    $[1] = ee_name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== auction || $[4] !== celebrity || $[5] !== ee_img || $[6] !== ee_name || $[7] !== id || $[8] !== t1) {
    t2 = <BaseExperienceCard ee_name={ee_name} ee_img={ee_img} id={id} auction={auction} celebrity={celebrity} imageComponent={t1} />;
    $[3] = auction;
    $[4] = celebrity;
    $[5] = ee_img;
    $[6] = ee_name;
    $[7] = id;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};